export default __webpack_public_path__ + "static/media/LogoHorizontal_Transparente.7fe3f2cc.png";